import van from "vanjs-core";
import { router, setPageContent } from "..";
import { assets, config } from "../app-env/common";
import { locale } from "../locale";
import { centeredBox } from "../van/centered-box";

const { button, div, figure, h1, h2, img } = van.tags;

/**
 * @param {DeviceType} deviceType}
 */
function registerDeviceCard(deviceType) {
	return div(
		{ class: `card ${deviceType}` },
		div(
			{
				class: "card-header is-clickable p-2",
				onclick: () => router.jump(`/devices/register/${deviceType}`),
			},
			div(
				{ class: "level is-mobile" },
				div(
					{ class: "level-item" },
					figure(
						{ class: "image is-64x64" },
						img({ src: assets[`${deviceType}.png`] }),
					),
				),
				div(
					{ class: "level-item" },
					div(
						h1({ class: "title is-4" }, productName[deviceType]),
						h2(
							{ class: "subtitle is-6" },
							productDetails[deviceType],
						),
					),
				),
			),
		),
	);
}

export function registerDevicePage() {
	const root = centeredBox(
		{ size: "narrow" },
		h1(
			{ class: "title is-5" },
			locale.string({
				enGB: "Select the product you wish to add",
				deDE: "Wählen Sie das Produkt, das Sie hinzufügen möchten",
				frFR: "Sélectionnez le produit que vous souhaitez ajouter",
				svSE: "Välj den produkt du vill lägga till",
			}),
		),
		...config.supportedDevices.map((id) => registerDeviceCard(id)),
		button(
			{
				class: "button is-primary",
				onclick: () => router.jump("/devices"),
			},
			locale.strings.back,
		),
	);
	setPageContent(root);
}

/**
 * @type {Object<DeviceType,string>}
 */
const productDetails = {
	"farmcam-sim": "Flex 4G, Mobility, Mobility S",
};

/**
 * @type {Record<DeviceType,string>}
 */
const productName = {
	"farmcam-sim": "FarmCam SIM",
	fencealarm: "FenceAlarm",
	fencealarm2: "FenceAlarm2",
	smartplug: "SmartPlug",
	smartplug2: "SmartPlug2",
};
